// test2222
(2222 && 0);
